import * as React from "react";
import useConfig from "../hooks/useConfig";

interface Props {
  timestamp: Date;
}

function MessageTimestamp(props: Props) {
  const config = useConfig();
  const oneDay = 86400000;

  function getRelativeDayText() {
    const timeStamp = props.timestamp;
    const currentDate = new Date();

    const differenceInMS = currentDate.valueOf() - timeStamp.valueOf();

    if (differenceInMS <= oneDay) {
      return config.TodayAtText;
    } else if (differenceInMS <= oneDay * 2) {
      return config.YesterdayAtText;
    }

    return null;
  }

  function getRelativeTimestampString() {
    const timeStamp = props.timestamp;

    let relativeDayText = getRelativeDayText();

    if (!relativeDayText) {
      relativeDayText = timeStamp.toLocaleDateString();
    }

    let locale = "en-US"; // uses 12 hour format

    if (config.Enable24HourTimestamps) {
      locale = "en-GB"; //uses 24 hour format
    }

    const timeText = timeStamp.toLocaleTimeString(locale, {
      hour: "2-digit",
      minute: "2-digit"
    });

    return `${relativeDayText} ${timeText}`;
  }

  return <div className={"timestamp"}>{getRelativeTimestampString()}</div>;
}

export default MessageTimestamp;
